import { useEffect, useRef } from 'react';

/**
 * Reloads the page at specific times of day.
 *   e.g. [{ hour: 0 }, { hour: 12 }, { hour: 18, minute: 30 }]
 */
export function useScheduledRefresh(schedule: Array<{ hour: number; minute?: number }>) {
  // This prevents the page from reloading more than once per scheduled slot.
  const firedRef = useRef(new Set());

  useEffect(() => {
    const now = new Date();
    firedRef.current.add(`${now.getHours()}:${now.getMinutes()}`);

    const check = () => {
      const now = new Date();
      const h = now.getHours();
      const m = now.getMinutes();
      const key = `${h}:${m}`;

      for (const { hour, minute = 0 } of schedule) {
        if (h === hour && m === minute && !firedRef.current.has(key)) {
          firedRef.current.add(key);
          window.location.reload();
          return;
        }
      }

      // Prune stale keys to keep the Set small
      if (firedRef.current.size > 1) {
        firedRef.current = new Set(firedRef.current.has(key) ? [key] : []);
      }
    };

    check();
    const id = setInterval(check, 20_000);
    return () => clearInterval(id);
  }, [schedule]);
}
